'use strict';

vehicleAlertDirective.$inject = [];

function vehicleAlertDirective() {
    var directive = {
        restrict: 'E',
        replace: true,
        controller: vehicleAlertDirectiveController,
        templateUrl: 'template/directives/vehicle-alert',
        scope: {
            alert: '=',
            displayButtons: '<?',
            onToggle: '=?'
        }
    };
    return directive;
}

vehicleAlertDirectiveController.$inject = ['$scope'];

function vehicleAlertDirectiveController($scope) {
    this.$postLink = function () {
        init();
    };

    $scope.toggleDescription = function () {
        $scope.descriptionShown = !$scope.descriptionShown;
    };

    $scope.togglePreselected = function () {
        $scope.alert.selected = !$scope.alert.selected;
        $scope.onToggle && $scope.onToggle();
    };

    function init() {
        $scope.description = $scope.alert.comment;
        $scope.title = $scope.alert.name;
    }
}

export default vehicleAlertDirective;
